import axios from 'axios';
import mbpLogger from 'mbp-logger';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var windowHostname;
var ENV_OBJ = {
  protocol: undefined,
  host: undefined,
  prefix: undefined,
  rootUri: undefined
};
var HTTP_HEADER_ACCEPTED_ENCODING = 'gzip, deflate';
var getEnvVarValue = function getEnvVarValue(variableName) {
  var value = process.env[variableName];
  try {
    if (windowHostname) {
      if (windowHostname.toLowerCase().indexOf('dev') !== -1) {
        value = process.env["".concat(variableName, "_DEV")];
      }
      if (windowHostname.toLowerCase().indexOf('uat') !== -1) {
        value = process.env["".concat(variableName, "_UAT")];
      }
    }
    if (!windowHostname) {
      value = process.env["".concat(variableName, "_SSR")];
    }
  } catch (ex) {
    mbpLogger.logError({
      variableName: variableName,
      "function": 'getEnvVarValue',
      module: 'member-api',
      jsError: ex,
      message: 'getEnvVarValue failed'
    });
  }
  return value || process.env[variableName];
};
var setHost = function setHost() {
  if (!ENV_OBJ.host) {
    if (windowHostname) {
      var host = getEnvVarValue('APP_WC_HOST');
      ENV_OBJ.host = host || windowHostname || 'localhost';
    } else {
      ENV_OBJ.host = process.env.APP_WC_HOST_SSR || 'localhost';
    }
  }
};
var setProtocol = function setProtocol() {
  if (!ENV_OBJ.protocol) {
    if (windowHostname) {
      ENV_OBJ.protocol = process.env.APP_WC_PROTOCOL || 'https';
    } else {
      ENV_OBJ.protocol = process.env.APP_WC_PROTOCOL_SSR || 'https';
    }
  }
};
var setPrefix = function setPrefix() {
  if (!ENV_OBJ.prefix) {
    if (windowHostname) {
      ENV_OBJ.prefix = typeof process.env.APP_API_PREFIX !== 'undefined' ? process.env.APP_API_PREFIX : '/r/api';
    } else {
      ENV_OBJ.prefix = typeof process.env.APP_API_PREFIX_SSR !== 'undefined' ? process.env.APP_API_PREFIX_SSR : '';
    }
  }
};
var setHeaders = function setHeaders(headersInput) {
  var headers = _objectSpread({}, headersInput);
  if (!windowHostname) {
    headers['Accept-Encoding'] = HTTP_HEADER_ACCEPTED_ENCODING;
  }
  return headers;
};

/**
 * {
 *   protocol: 'http',
 *   host: undefined,
 *   rootUri: '/wcs/resources/store/',
 *   storeId: undefined,
 *   brand: undefined,
 * }
 */
var MEM_ENV = function MEM_ENV() {
  if (!ENV_OBJ.host) {
    windowHostname = typeof window !== 'undefined' && window.location && window.location.hostname;
    mbpLogger.logDebug({
      windowHostname: windowHostname,
      APP_WC_HOST: process.env.APP_WC_HOST,
      APP_WC_HOST_SSR: process.env.APP_WC_HOST_SSR,
      "function": 'member',
      module: 'member-api',
      message: 'MEM_ENV variables'
    });
    setHost();
    setPrefix();
    setProtocol();
    mbpLogger.logDebug({
      ENV_OBJ: ENV_OBJ,
      "function": 'MEM_ENV',
      module: 'member-api',
      message: 'MEM_ENV object'
    });
  }
  return ENV_OBJ;
};

/**
 * add jwtToken as a header
 * @param {*} jwt_token
 * @param {*} config
 */
var addJwtToken = function addJwtToken(jwtToken) {
  if (!jwtToken || jwtToken === '') {
    return 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik16ZENSRUZGTWpkRVJUaERNalJDUWpSQ016TkJNakE1TURrMk5FWTNORFF6UVVZNE9UYzVNQSJ9.eyJodHRwczovLzgwMC1mbG93ZXJzLm5ldCI6eyJ0eXBlIjoiZ3Vlc3QiLCJzeXN0ZW1JRCI6IkFVVEgwLUdVRVNULTEwMDAwMDAwMDAwMDAwMDI5MjIiLCJjb250YWN0SWQiOiJHVUVTVC0xMDAwMDAwMDAwMDAwMDAyOTIyIn0sImlzcyI6Imh0dHBzOi8vZmxvd2Vyc3Rlc3QuYXV0aDAuY29tLyIsInN1YiI6Imdsb2lVRGxSeDdoaklBR3JlUDRpZ2o0c0RGdTlzYzN4QGNsaWVudHMiLCJhdWQiOiJodHRwczovL2RldjEub3JpZ2luLWdjcC44MDAtZmxvd2Vycy5uZXQiLCJpYXQiOjE1MzcyMTczMjUsImV4cCI6MTUzNzMwMzcyNSwiYXpwIjoiZ2xvaVVEbFJ4N2hqSUFHcmVQNGlnajRzREZ1OXNjM3giLCJzY29wZSI6ImN1c3RvbWVyOmNoZWNrb3V0IiwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIn0.NavrE2LDwYJM5e3WP9DD2cPBikUkGOv-bwfCoUSfWNx04iXWZRo_CKYOzKlKFHn78q2ChGI3otzP_x5Yb69Hl4EcfSXJ4by4PDBk5Vu9CQ3s4VWFpYyzycxsGLmLU_pGLiM44mpfQ8OWv_SMJyQKqcYiRNupUS2P2K1Jgus4l-gCRIkCgJ6IHpA7h9N9BK-WCpU32EDQXUIGWTwMU1i_861w0sWVD2NqP3ugxqQC_gahQ4y4m7_MBKTiPfdUhmQkaN82A-j7_5ndcO9QaDDcRzGwuvMxTmKQMqSNifGZMsNjO0UzdZD6HigOi_L-2iDm9NCo27gxajseuEPKrcSVbg';
  }
  return "Bearer ".concat(jwtToken);
};

/**
 * Call Axios to execute remote call to member services hosted
 * Note: brand will get added as parameter on the URL
 *
 * @param method    - get/post/put/delete/etc
 * @param url       - string for url to call
 * @param params    - object with parameters to be added to the url
 * @param data      - body
 * @param env     -   environment properties
 * @param jwtToken  - JWT Access Token
 * @param header    - object with headers to be added to the request
 */
var callAxios = function callAxios(method, url, params, data, env, jwtToken, headers) {
  try {
    // Bail if no GUID or JWT provided
    if (data && !data.guid && !jwtToken) {
      return false;
    }
    var config = {
      method: method,
      url: url,
      params: _objectSpread({}, params),
      headers: setHeaders(headers),
      data: data
    };
    if (jwtToken) {
      config.headers = _objectSpread({
        Authorization: addJwtToken(jwtToken)
      }, config.headers);
    }
    return axios(config);
  } catch (ex) {
    mbpLogger.logError({
      method: method,
      url: url,
      params: params,
      data: data,
      env: env,
      jwtToken: jwtToken,
      headers: headers,
      "function": 'callAxios',
      module: 'MEMBER-api',
      jsError: ex,
      message: 'callAxios FAILED'
    });
  }
  return null;
};

/**
 * Builds the url
 * FIXME: move addition of storeId from env to MEMBER-api client functions.
 * @param {*} env  - if empty uses default.
 * @param String resourcePath
 */
var getUrl = function getUrl(env, resourcePath) {
  mbpLogger.logDebug({
    env: env,
    resourcePath: resourcePath,
    envObj: MEM_ENV(),
    "function": 'getUrl',
    module: 'member-api',
    message: 'getUrl variables'
  });
  var hostUrl = "".concat(env.protocol || MEM_ENV().protocol, "://").concat(env.host || MEM_ENV().host);
  var uri = "".concat(env.prefix || MEM_ENV().prefix);
  var url = "".concat(hostUrl).concat(uri, "/").concat(resourcePath);
  mbpLogger.logDebug({
    url: url,
    uri: uri,
    hostUrl: hostUrl,
    "function": 'getUrl',
    module: 'member-api',
    message: 'getUrl variables'
  });
  return url;
};

/**
 * GET for WC api calls
 * @param {*} env
 * @param {*} resourcePath
 * @param {*} params
 */
var performGet = function performGet(env, resourcePath, jwtToken, params) {
  try {
    mbpLogger.logDebug({
      params: params,
      "function": 'performGet',
      module: 'MEMBER-api',
      message: 'performGet params'
    });
    var url = getUrl(env, resourcePath);
    return callAxios('get', url, params, null, env, jwtToken);
  } catch (ex) {
    mbpLogger.logError({
      env: env,
      resourcePath: resourcePath,
      jwtToken: jwtToken,
      params: params,
      // TODO: Review for removal (PII) before live
      "function": 'performGet',
      module: 'MEMBER-api',
      jsError: ex,
      message: 'WC SDK performGet failed'
    });
  }
  return null;
};
var performPost = function performPost(env, resourcePath, jwtToken, data) {
  try {
    mbpLogger.logDebug({
      data: data,
      "function": 'performPost',
      module: 'MEMBER-api',
      message: 'performPost: data'
    });
    var url = getUrl(env, resourcePath);
    return callAxios('post', url, null, data, env, jwtToken);
  } catch (ex) {
    mbpLogger.logError({
      env: env,
      resourcePath: resourcePath,
      jwtToken: jwtToken,
      data: data,
      // TODO: Review for removal (PII) before live
      "function": 'performPost',
      module: 'MEMBER-api',
      jsError: ex,
      message: 'member sdk failed '
    });
  }
  return null;
};

/**
 * PUT method
 * @param {*} env
 * @param {*} resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */

var performPut = function performPut(env, resourcePath, jwtToken, data) {
  return callAxios('put', getUrl(env, resourcePath), null, data, env, jwtToken, null);
};

/**
 * DELETE method
 * @param {*} env
 * @param {*} resourcePath
 * @param {*} jwtToken
 * @param {*} data
 */
var performDelete = function performDelete(env, resourcePath, jwtToken, data) {
  return callAxios('delete', getUrl(env, resourcePath), null, data, env, jwtToken, null);
};

/**
 * @class member Apis
 */
var memberClient = {
  performGet: performGet,
  performPost: performPost,
  performPut: performPut,
  performDelete: performDelete
};
export { memberClient as default };